import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import urlJoin from 'url-join';

import { toFilteringUrl } from '../utility';
import { ApiResponse } from '../models/api-response';
import { SharedService } from './shared.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient ,public sharedService: SharedService, private appConfig: AppConfigService) {}

  getUsers(filter: any): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      toFilteringUrl(urlJoin(this.appConfig.apiUrl2, '/User/GetUsers'), filter),
    );
  }

  getUserDetails(userId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      urlJoin(this.appConfig.apiUrl2, '/User/GetUSERDetails', `?userId=${userId}`),
       this.sharedService.getHeaders()
    );
  }

  getUserPermissions(id: number, portalId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      urlJoin(this.appConfig.apiUrl2, `User/GetUserPermissions?userId=${id}&portalId=${portalId}`),
    );
  }

  addUser(role: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(urlJoin(this.appConfig.apiUrl2 ,'/User/AddUser'), role);
  }

  updateUser(data: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(urlJoin(this.appConfig.apiUrl2, '/User/EditUser'), data);
  }

  logoutUser(userId: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      urlJoin(this.appConfig.apiUrl2, '/User/Logout', `?userId=${userId}`),
      {},
    );
  }
  getPortals() {
    const headers = this.sharedService.getHeaders();
    return this.http.get<ApiResponse>(
      urlJoin(this.appConfig.apiUrl2, '/User/GetUserPortals',),
      headers,
    );
  }
  GetUserDetails(id: number) {
    return this.http.get(
      urlJoin(this.appConfig.apiUrl2, `User/GetUSERDetails?userId=${id}`),
      this.sharedService.getHeaders()
    );
  }

  decodeToken(token?:any) {
    const helper = new JwtHelperService();
    return helper.decodeToken(token);
  }
  get getBranch() {
    const branch = localStorage.getItem('branch');
    return branch !== null ? JSON.parse(branch) : null;
  }
}
